import(/* webpackMode: "eager" */ "/app/app/(legal)/[lang]/error.tsx");
